import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { MigrationProvider } from "../contexts/MigrationContext";
import { DialogProvider } from "../contexts/DialogContext";
import { UserProvider } from "../contexts/UserContext";

export const MigrationComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[
        <MigrationProvider key={0} />,
        <UserProvider key={1} />,
        <DialogProvider key={2} />,
      ]}
    >
      {children}
    </ContextProviderComposer>
  );
};
